export default __webpack_public_path__ + "static/autograph_collection-bea2d3178a387abdf911ce1dbbb35190.png";